import React, { memo } from "react";

import styled from "styled-components";

import {
  AccordionProps,
  Accordion as ODSAccordion,
  Text,
} from "@origin-digital/ods-core";

const Accordion = styled(ODSAccordion)(() => ({
  "&& ": {
    marginTop: 24,
    marginBottom: 24,
  },
}));

/* istanbul ignore next */
const StyledAccordion = memo(
  ({ id = "", summary, children, ...restProps }: AccordionProps) => {
    return (
      <>
        <Accordion id={id} summary={summary} {...restProps}>
          <Text>{children}</Text>
        </Accordion>
      </>
    );
  }
);

export { StyledAccordion };
